const WorklistLoader = () => {
  return Array.from(Array(10)).map((num, index) => (
    <li key={index} className="bg-gray-100 dark:bg-gray-900">
      <div className="animate-pulse flex space-x-4 px-6 py-5 items-center text-md">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded"></div>
          <div className="h-4 w-1/2 bg-gray-300 dark:bg-gray-700 rounded col-span-2"></div>
          <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded"></div>
        </div>
      </div>
    </li>
  ));
};

export default WorklistLoader;
